
export interface TabNotification {
  type: 'data_cleared' | 'operation_started' | 'operation_completed' | 'error_occurred';
  operation: string;
  sessionId: string;
  timestamp: number;
  data?: any;
}

export class CrossTabNotifier {
  private channel: BroadcastChannel;
  private listeners: Map<string, ((notification: TabNotification) => void)[]> = new Map();
  private sessionId: string;

  constructor() {
    this.sessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    this.channel = new BroadcastChannel('data_management_notifications');
    this.setupListener();
  }

  private setupListener() {
    this.channel.onmessage = (event: MessageEvent<TabNotification>) => {
      const notification = event.data;
      
      // Não processar notificações da própria sessão
      if (notification.sessionId === this.sessionId) {
        return;
      }

      const typeListeners = this.listeners.get(notification.type) || [];
      typeListeners.forEach(listener => {
        try {
          listener(notification);
        } catch (error) {
          console.error('Erro ao processar notificação entre abas:', error);
        }
      });
    };
  }

  notify(type: TabNotification['type'], operation: string, data?: any): void {
    const notification: TabNotification = {
      type,
      operation,
      sessionId: this.sessionId,
      timestamp: Date.now(),
      data
    };

    try {
      this.channel.postMessage(notification);
      console.log(`Notificação enviada: ${type} - ${operation}`);
    } catch (error) {
      console.error('Erro ao enviar notificação entre abas:', error);
    }
  }

  onNotification(type: TabNotification['type'], callback: (notification: TabNotification) => void): void {
    if (!this.listeners.has(type)) {
      this.listeners.set(type, []);
    }
    this.listeners.get(type)!.push(callback);
  }

  removeListener(type: TabNotification['type'], callback: (notification: TabNotification) => void): void {
    const typeListeners = this.listeners.get(type);
    if (typeListeners) {
      const index = typeListeners.indexOf(callback);
      if (index > -1) {
        typeListeners.splice(index, 1);
      }
    }
  }

  destroy(): void {
    this.channel.close();
    this.listeners.clear();
  }
}
